import { FormBase } from 'core/components';
import validatorjs from 'validatorjs';

export default class PasswordRecoveryChangeForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}

	setup() {
		var Validator = validatorjs;
		Validator.register(
			'password',
			value => {
				return value.trim().match(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(^.{12,}$)/);
			},
			'PASSWORDMINREQUIREMENTS'
		);
		return {
			fields: [
				{
					name: 'password',
					label: 'LOGINFORM.PASSWORD',
					type: 'password',
					rules: ['required', 'string', 'min:8', 'password'],
				},
				{
					name: 'confirmPassword',
					label: 'LOGINFORM.CONFIRMPASSWORD',
					rules: 'required|string|same:password',
					type: 'password',
				},
			],
		};
	}
}
